import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import styles from './styles';

class B24europa extends React.Component {
  renderContent() {
    const { classes, blockData } = this.props;

    return (
      <div className={classes.content}>
        <div className={classes.main}>
          <div className={classes.desc1}>
            {blockData.desc1.map((item, idx) => (
              <Typography key={idx} variant="body1" className={classes.desc}>
                {parse(item)}
              </Typography>
            ))}
          </div>
          <div className={classes.desc2}>
            {blockData.desc2.map((item, idx) => (
              <Typography key={idx} variant="body1" className={classes.desc}>
                {parse(item)}
              </Typography>
            ))}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { classes, blockData, baseUrl } = this.props;
    const mainTitle = parse(blockData.mainTitle);
    const baseUrlBlock = `${baseUrl}/blocks/`;
    return (
      <div style={{ backgroundImage: `url(${baseUrlBlock}${blockData.bg})` }} className={classes.blockContainer}>
        <Typography variant="h1" className={classes.mainTitle}>
          {mainTitle}
        </Typography>
        {this.renderContent()}
      </div>
    );
  }
}

B24europa.propTypes = {
  classes: PropTypes.object.isRequired,
  blockData: PropTypes.object,
  baseUrl: PropTypes.string.isRequired,
};

export default withStyles(styles)(B24europa);
